import type {ComponentProps, ReactNode } from 'react';

import { cn } from './cn';

export function Card({ className, ...props }: ComponentProps<'div'>): ReactNode {
	return (
		<div
			className={cn('rounded-card border border-border bg-surface', className)}
			{...props}
		/>
	);
}

export function CardBody({ className, ...props }: ComponentProps<'div'>): ReactNode {
	return <div className={cn('p-5', className)} {...props} />;
}
